import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ControlContainer, FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { NoDataLabelConfig } from 'src/app/modules/shared/models/section-config.model';

@Component({
    selector: 'no-data-label-configuration',
    templateUrl: 'no-data-label-configuration.component.html',
    styleUrls: ['no-data-label-configuration.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NoDataLabelConfigurationComponent implements OnInit {
  @Input() parentFormGroup: FormGroup;
  @Input() noDataLabelConfig: NoDataLabelConfig;

  expanded: boolean = false;
  form: FormGroup;  

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.addControls();
  }

  private addControls(): void {
    this.form = this.fb.group({
      show: this.fb.control(this.noDataLabelConfig?.show),
      withRedictToLabConnections: this.fb.control(this.noDataLabelConfig?.withRedictToLabConnections)
    });
    this.parentFormGroup.addControl('noDataLabelConfig', this.form);
  }
}